import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "@/elements/components/utils/convex-api";
import Loader from "@/elements/components/shared/loader";
import React, { Fragment } from "react";
import TutorNoShowScreen from "@/elements/components/no-show/tutor-no-show";

function ReportTutorNoShowScreen() {
  const { data: currentUser, isSuccess: isCurrentUserSuccess } = useQuery(
    convexQuery(api.account.queries.getCurrentUser, {})
  );

  if (!isCurrentUserSuccess) {
    return <Loader />;
  }

  return <TutorNoShowScreen />;
}

export default ReportTutorNoShowScreen;
